import React, { useCallback } from "react";
import { Link } from "react-router-dom";
import {useRecoilState, useRecoilValue} from "recoil";
import { notificationMsgsState } from "../../atoms/notificationAtom";

import "./styles.scss";

import i18next from "i18next";

const NotificationDropDown = ({ notificationRef, sendMsgNotify }) => {
  const [notificationMsgs, setNotificationMsgs] = useRecoilState(notificationMsgsState);

  /** START: WebSocket data send **/
  const handleNotificationClick = useCallback(
    (id) => () => {
      const notificationId = id;

        function removeNotificationFromList(item) {
            return item.id !== notificationId;
        }

      if (notificationMsgs?.notifications?.filter((ele) => ele.id === notificationId)) {

          // Send websocket message to remove notification from the list in database
          sendMsgNotify(notificationId);

          // remove notification by ID from local state
          setNotificationMsgs({
              notifications: notificationMsgs.notifications.filter(removeNotificationFromList)
          });
      }
    },
    [useCallback]
  );
  /** END: WebSocket data send **/

  const regex = /('(?=(,\s*')))|('(?=:))|((?<=([:,]\s*))')|((?<={)')|('(?=}))/g;

  return (
    <div ref={notificationRef} className={"notification-dropdown-wrapper"}>
      <div className={"notification-dropdown-info-title"}>Notifications</div>
      {notificationMsgs?.notifications?.map((item, key) => (
        <div className={"notification-dropdown-info"} key={item.id} onClick={handleNotificationClick(item.id)}>
          <Link to="#" className={"notification-dropdown-info-text"}>
            {JSON.parse(item.message.replace(regex, '"'))[`message_${i18next.language}`]}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default NotificationDropDown;
